module.exports = __webpack_public_path__ + "img/ajuste_matricula.8e4456b3.svg";